import { render, staticRenderFns } from "./table.vue?vue&type=template&id=26020c66&"
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26020c66')) {
      api.createRecord('26020c66', component.options)
    } else {
      api.reload('26020c66', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=26020c66&", function () {
      api.rerender('26020c66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/table.vue"
export default component.exports